"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _SVGIcon = _interopRequireDefault(require("@instructure/ui-svg-images/lib/components/SVGIcon"));

var _ref =
/*#__PURE__*/
_react.default.createElement("path", {
  d: "M1803.305 1337.072L1919.958 1920l-582.928-116.653-950.128-950.015 79.15-79.15 801.792 801.68 307.977-307.976-907.362-907.474L281.22 747.65 49.034 515.464c-65.379-65.603-65.379-172.069 0-237.448l228.94-228.94c65.267-65.379 171.733-65.49 237.448 0l232.186 232.187 1055.697 1055.809zm-411.196 363.056l385 77.023-77.023-385-45.116-45.116-307.977 307.977 45.117 45.116zM281.222 589.352l308.089-308.09-59.11-59.11-93.927-93.926c-10.972-10.971-25.301-16.345-39.63-16.345-14.33 0-28.548 5.374-39.52 16.345l-228.94 228.94c-21.718 21.718-21.718 57.318 0 79.149l153.038 153.037zm394.134 6.907l692.304 692.304-79.149 79.15-692.304-692.305 79.149-79.15z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconEdit =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(IconEdit, _Component);

  function IconEdit() {
    (0, _classCallCheck2.default)(this, IconEdit);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(IconEdit).apply(this, arguments));
  }

  (0, _createClass2.default)(IconEdit, [{
    key: "render",
    value: function render() {
      return _react.default.createElement(_SVGIcon.default, Object.assign({}, this.props, {
        name: "IconEdit",
        viewBox: "0 0 1920 1920",
        bidirectional: true
      }), _ref);
    }
  }]);
  IconEdit.displayName = "IconEdit";
  return IconEdit;
}(_react.Component);

exports.default = IconEdit;
IconEdit.glyphName = 'edit';
IconEdit.variant = 'Line';
IconEdit.propTypes = (0, _objectSpread2.default)({}, _SVGIcon.default.propTypes);